import { render } from "./legoModal.vue?vue&type=template&id=34584e98"
import script from "./legoModal.vue?vue&type=script&lang=js"
export * from "./legoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoModal/legoModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34584e98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34584e98', __exports__)) {
    api.reload('34584e98', __exports__)
  }
  
  module.hot.accept("./legoModal.vue?vue&type=template&id=34584e98", () => {
    api.rerender('34584e98', render)
  })

}


export default __exports__